module.exports = Function.prototype.call.bind(Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// ./~/react-router/modules/helpers/hasOwnProperty.js
// module id = 203
// module chunks = 0